import { Component } from '@angular/core'
import { NgbNav, NgbNavContent, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap'

import { BaseComponent, FabHoldReason, FabJob, FabProcessStep, FabUnresolvedJob, FeatureType, ListItem, VpJob } from '../../shared'
import { FabHoldReasonsListComponent } from './fab-hold-reasons-list.component'
import { FabJobsListComponent } from './fab-jobs-list.component'
import { FabProcessStepsListComponent } from './fab-process-steps-list.component'

@Component({
    selector: 'app-fab-setup',
    templateUrl: './fab-setup.component.html',
    standalone: true,
    imports: [
        NgbNav,
        NgbNavContent,
        NgbNavItem,
        NgbNavItemRole,
        NgbNavLink,
        NgbNavLinkBase,
        NgbNavOutlet,
        FabProcessStepsListComponent,
        FabJobsListComponent,
        FabHoldReasonsListComponent,
    ],
})
export class FabSetupComponent extends BaseComponent {
    activeTab = 1
    processSteps: FabProcessStep[] = []
    jobs: FabJob[] = []
    holdReasons: FabHoldReason[] = []
    vpJobOptions: ListItem<string>[] = []
    unresolvedJobs: FabUnresolvedJob[] = []
    unresolvedExpanded = false

    constructor() {
        super()
        this.refresh()
    }

    get canEdit() {
        return this.services.authentication.hasFeature([FeatureType.FabSetupEdit])
    }

    tabChanged() {
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'))
        }, 50)
    }

    refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data
                .load(
                    true,
                    true,
                    this.services.data.fabProcessSteps.queryAll(),
                    this.services.data.fabJobs.queryAll(),
                    this.services.data.vpJobs.queryAllByAction('GetActiveAndSoftClose'),
                    this.services.data.fabHoldReasons.queryAll(),
                    this.services.data.get<FabUnresolvedJob[]>('api/FabJob/UnresolvedReport'),
                )
                .subscribe({
                    next: result => {
                        this.initialLoadingComplete()
                        this.processSteps = result[0]
                        this.jobs = result[1]
                        const vpJobs = (result[2] as VpJob[]).slice().sort((a, b) =>
                            a.id.trim().localeCompare(b.id.trim(), undefined, { numeric: true }),
                        )
                        this.holdReasons = result[3]
                        this.unresolvedJobs = result[4] || []
                        this.vpJobOptions = [
                            new ListItem('', 'Select a job'),
                            ...vpJobs.map(j => new ListItem(j.id, `${j.id.trim()} ${j.name}`)),
                        ]
                    },
                }),
        )
    }

    exportUnresolvedCsv() {
        const header = [
            'ScheduleReference',
            'Name',
            'VpJobId',
            'IsInternal',
            'PieceCount',
            'Sample DWG #',
            'Reason',
        ]
        const lines = this.unresolvedJobs.map(r =>
            [
                r.scheduleReference,
                r.name,
                r.vpJobId,
                r.isInternal ? '1' : '0',
                r.pieceCount,
                r.sampleMarks,
                r.reason,
            ]
                .map(v => csvCell(v))
                .join(','),
        )
        const blob = new Blob([[header.join(','), ...lines].join('\r\n')], { type: 'text/csv;charset=utf-8' })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = 'fab-unresolved-jobs.csv'
        a.click()
        URL.revokeObjectURL(url)
    }

    onChildModified() {
        this.refresh()
    }
}

function csvCell(value: unknown): string {
    const s = value == null ? '' : String(value)
    if (/[",\r\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`
    return s
}
